import { render, staticRenderFns } from "./ZDMFailureReport.vue?vue&type=template&id=2ed2cbf9&scoped=true&"
import script from "./ZDMFailureReport.vue?vue&type=script&lang=js&"
export * from "./ZDMFailureReport.vue?vue&type=script&lang=js&"
import style0 from "./ZDMFailureReport.vue?vue&type=style&index=0&id=2ed2cbf9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2cbf9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VChip,VCol,VFileInput,VForm,VRow,VTextarea,VTooltip})
